import MyCardsPage from './MyCardsPage';

export default MyCardsPage;
